// extracted by mini-css-extract-plugin
module.exports = {"Loader":"_2iSOkhUGYmgzCjws9W9yVW","lds-ripple":"_1XXys1vwwccttSoGaGWdQL","center":"_1YZNWLE3yYnKT0N8UDAVHy"};